/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Rocket16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M14 1a1 1 0 011 1v.93a5.463 5.463 0 01-1.61 3.891L11.5 8.705V12.5a.497.497 0 01-.19.39l-2.5 2a.5.5 0 01-.804-.319l-.43-3.004c-.001-.012.004-.022.003-.033-.13.01-.27.031-.391.031-.883 0-1.567-.239-2.041-.71-.535-.536-.75-1.36-.678-2.422-.011 0-.022.003-.033.002h-.001l-3.004-.43a.499.499 0 01-.32-.809l2-2.5A.502.502 0 013.5 4.5h3.795L9.18 2.611A5.46 5.46 0 0113.07 1zM5.29 13.001a.5.5 0 01.707.707l-.707.707a.5.5 0 01-.707-.707zm-2-1a.5.5 0 01.707.707l-1.414 1.414a.5.5 0 01-.707-.707zm10.71-10h-.93a4.467 4.467 0 00-3.18 1.32L7.857 5.356A.5.5 0 017.5 5.5H3.74L2.436 7.13l2.14.305c.094.014.405.058.498.07a.502.502 0 01.422.57c-.146.99-.026 1.687.359 2.072.384.385 1.083.505 2.073.36a.496.496 0 01.568.42c.013.09.067.401.08.497l.305 2.142 1.62-1.306V8.5a.498.498 0 01.145-.355l2.035-2.034A4.474 4.474 0 0014 2.931V2zM2.29 10a.5.5 0 01.707.707l-.707.707a.5.5 0 01-.707-.707zm5.71-3A1 1 0 118.002 9a1 1 0 010-2z"
        />
    </AccessibleSVG>
);

export default Rocket16;
